import React from 'react'
import { useForm } from 'react-hook-form'

import { LntButton, LntForm, LntFormItem, LntModalFooter, LntSelect } from '@app/components/base'

import { FILTERS_PLACEHOLDERS } from '@app/constants/filters'
import { LOCATION_KEY, MONITORINGS_TYPES_KEY } from '@app/constants/queryKeys'
import { BUTTON_TYPE, SIZE } from '@app/constants'

import { getTypes } from '@app/api/routes/monitorings'
import { getClusters } from '@app/api/routes/locationСlusters'
import { getClusterGroups } from '@app/api/routes/locationClusterGroups'

import { getFilterFromEntities } from '@app/utils/entitiesAdapters'

import styles from './styles.module.scss'

import type { CopyArchivesListModalProps } from '../types'
import type { CopyArchivesItem } from '@app/api/routes/monitoringLists/types'
import type { LntSelectProps } from '@app/components/base/Select/types'

const commonSelectProps: LntSelectProps = {
  showArrow: true,
  mode: 'multiple',
  size: SIZE.middle
}

export const CopyArchivesListForm: React.FC<Pick<CopyArchivesListModalProps, 'onSubmit'>> = ({ onSubmit }) => {
  const form = useForm<CopyArchivesItem>()

  const handleSubmit = (data: CopyArchivesItem): void => {
    onSubmit?.(data)
  }

  return (
    <LntForm
      layout='vertical'
      onSubmit={ handleSubmit }
      formInstance={ form }
    >
      <div className={ styles.form__itemsWrapper }>
        <LntFormItem
          name='clusterIds'
          defaultValue={ [] }
          validationOptions={ { rules: { required: true } } }
        >
          <LntSelect
            { ...commonSelectProps }
            placeholder={ `${FILTERS_PLACEHOLDERS.clustersFilter}` }
            querySelect={ {
              queryKey: [LOCATION_KEY.locationClustersItems],
              queryFn: getClusters,
              select: getFilterFromEntities
            } }
          />
        </LntFormItem>

        <LntFormItem
          name='clustersGroupIds'
          defaultValue={ [] }
        >
          <LntSelect
            { ...commonSelectProps }
            placeholder={ `${FILTERS_PLACEHOLDERS.clusterGroupsFilter}` }
            querySelect={ {
              queryKey: [LOCATION_KEY.locationClusterGroupsItems],
              queryFn: getClusterGroups,
              select: getFilterFromEntities
            } }
          />
        </LntFormItem>

        <LntFormItem
          name='monitoringTypeIds'
          defaultValue={ [] }
        >
          <LntSelect
            { ...commonSelectProps }
            placeholder={ `${FILTERS_PLACEHOLDERS.monitoringsTypeFilter}` }
            querySelect={ {
              queryKey: [MONITORINGS_TYPES_KEY.typesItems],
              queryFn: getTypes,
              select: getFilterFromEntities
            } }
          />
        </LntFormItem>
      </div>
      <LntModalFooter>
        <LntButton
          className={ styles.form__button }
          type={ BUTTON_TYPE.primary }
          size={ SIZE.middle }
          htmlType='submit'
        >
          Копировать список
        </LntButton>
      </LntModalFooter>
    </LntForm>
  )
}
